import React from "react";
import { Alert, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import {
  DocuClipperPlan,
  StepWizardProps,
  StripePlan,
  StripeSubscription,
} from "../../../../docuclipper/DocuclipperTypes";
import { ReduxState } from "../../../../redux";
import { Btn } from "../../../../shared/Btn";
import { Spinner } from "../../../../shared/Spinner";

type Props = {
  plans: StripePlan[];
  onConfirmed: (plan: DocuClipperPlan) => any;
  subscription: StripeSubscription;
  selectedPlan: DocuClipperPlan;
};
export const _ConfirmDowngrade: React.SFC<
  Props & StepWizardProps & RouteComponentProps
> = ({ plans, nextStep, onConfirmed, history, subscription, selectedPlan }) => {
  const { user, loading } = useSelector((state: ReduxState) => state.User);
  if ((plans || []).length === 0) {
    return null;
  }

  if (loading) {
    return <Spinner size="md" center />;
  }
  const findPlanPages = (name: string): number => {
    const match = plans.find((p) => p.docuclipperPlan.name === name);
    return match?.docuclipperPlan.numPages ?? 0;
  };

  const starterPages = findPlanPages("Starter");
  const businessPages = findPlanPages("Business");
  const professionalPages = findPlanPages("Professional");

  let pagesAfterDowngrade = starterPages;
  if (selectedPlan === "Professional") {
    pagesAfterDowngrade = professionalPages;
  } else if (selectedPlan === "Business") {
    pagesAfterDowngrade = businessPages;
  }
  let retention =
    "File retention will be reduced on your new plan.";
  switch (selectedPlan) {
    case "Starter":
      retention =
        "Conversions will be retained for 1 year. Older files will be automatically removed.";
      break;
    case "Professional":
      retention =
        "Conversions will be retained for 1 year. Older files will be automatically removed.";
      break;
    case "Business":
      retention =
        "Conversions will be retained for 2 years. Older files will be automatically removed.";
      break;
  }
  return (
    <>
      <div className="text-center justify-content-center">
        <div className="h4">{`Before you downgrade, ${
          user ? user.firstName : ""
        }`}</div>
        <div
          className="my-4"
          style={{ maxWidth: "400px", marginLeft: "auto", marginRight: "auto" }}
        >{`Remember that after downgrading to DocuClipper ${selectedPlan}:`}</div>

        <Alert variant="warning" className="m-2">
          {`Your page allowance will change from ${subscription.docuclipperPlan.numPages} to ${pagesAfterDowngrade} pages per month.`}
        </Alert>

        <Alert variant="warning" className="m-2">
          Premium support is included on Business and higher plans. It will not be available on the new plan.
        </Alert>

        <Alert variant="warning" className="m-2">
          {retention}
        </Alert>
        <Row className="mt-4 justify-content-center">
          {/* <div>
            
            <a href="mailto:support@docuclipper.com">
              <Button variant="primary">Contact support</Button>
            </a>
          </div> */}
          <div>
            <Btn
              className="ml-2  btn--go-back-docuclipper"
              variant="primary"
              onClick={() => {
                history.push("/");
              }}
            >
              Go back to DocuClipper
            </Btn>
          </div>
          <div>
            <Btn
              className="ml-2 btn--still-want-downgrade"
              variant="secondary"
              onClick={() => {
                onConfirmed(selectedPlan);
              }}
            >
              I still want to downgrade
            </Btn>
          </div>
        </Row>
      </div>
    </>
  );
};
export const ConfirmDowngrade = withRouter(_ConfirmDowngrade);
export default ConfirmDowngrade;
